/**
 * REST API compatibility wrapper for AWS Amplify v6.
 * Preserves the v2-style `API.get/post/put/del(apiName, path, init)` interface
 * so that service files require only an import change.
 */
import { get as ampGet, post as ampPost, put as ampPut, del as ampDel } from 'aws-amplify/api';

const parseBody = async (response: any): Promise<any> => {
    try {
        if (response.body) {
            return await response.body.json() as any;
        }
    } catch {
        // body may not be JSON-parseable (e.g. 204 No Content)
    }
    return undefined;
};

export const API = {
    get: async (apiName: string, path: string, _init: any = {}): Promise<any> => {
        const restOperation = ampGet({ apiName, path });
        const { body } = await restOperation.response;
        return body.json() as any;
    },
    post: async (apiName: string, path: string, init: any = {}): Promise<any> => {
        const restOperation = ampPost({
            apiName,
            path,
            options: init.body !== undefined ? { body: init.body } : undefined,
        });
        const { body } = await restOperation.response;
        return body.json() as any;
    },
    put: async (apiName: string, path: string, init: any = {}): Promise<any> => {
        const restOperation = ampPut({
            apiName,
            path,
            options: init.body !== undefined ? { body: init.body } : undefined,
        });
        const { body } = await restOperation.response;
        return body.json() as any;
    },
    del: async (apiName: string, path: string, init: any = {}): Promise<any> => {
        const restOperation = ampDel({
            apiName,
            path,
            options: init.body !== undefined ? { body: init.body } : undefined,
        });
        const response = await restOperation.response;
        return parseBody(response);
    },
};
